<template>
  <div>
    <gc-order-express-base :express-detail="expressDetail" @downloadExpressOutFile="downloadExpressOutFile1"></gc-order-express-base>
  </div>
</template>

<script>
import GcOrderExpressBase from './components/GcOrderExpressBase.vue'

export default {
  name: 'GcOrderExpress',
  components: { GcOrderExpressBase },
  data () {
    return {
      expressDetail: []
    }
  },
  async created () {
    this.expressDetail = JSON.parse(this.$route.params.expressDetail)
  },
  methods: {
    downloadExpressOutFile1: function (contractNo) {
      this.$emit('downloadExpressFile', contractNo)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// GcOrderExpressWithData.vue?b75aa9e6